import React from "react";
import { useState, useContext, useEffect } from "react";
import { ChatContext } from "../../contexts/ChatContext/ChatContext";
import TextField from "../Input/TextField";
import Conversation from "./Conversation";
import { ConversationContext } from "../../contexts/ChatContext/ConversationContext"
import { InformationBasicContext } from "../../contexts/InformationBasicContext/InformationBasicContext"
import Alert from "../../components/Alert/Alert";

const Chat = () => {
    const [question, setQuestion] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [alert, setAlert] = useState(false);
    const [dots, setDots] = useState(".");

    const { CreateChat } = useContext(ChatContext);
    const { setConversation } = useContext(ConversationContext);
    const { full_name, companies } = useContext(InformationBasicContext);

    useEffect(() => {
      if (isDisabled && companies.length > 0) {
        const interval = setInterval(() => {
          setDots(prev => (prev.length < 3 ? prev + '.' : '.'));
        }, 500);
        return () => clearInterval(interval);
      } else {
        setDots('');
      }
    }, [isDisabled,  companies.length]);

    useEffect(() => {
      if (companies.length === 0) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }, [companies]);
    
    const sendQuestion = async (event) => {
      if (question !== "") {
        const questionToSend = question;
        
        setQuestion("");
        setIsDisabled(true);
        setConversation(prev => [
          ...prev,
          { 
            question: questionToSend, 
            answer: null, 
            full_name,
            formatted_date: new Date().toLocaleTimeString("es-ES", {
              hour: "2-digit",
              minute: "2-digit"
            })
          }
        ]);      
        
        const success = await CreateChat(questionToSend);
        
        setIsDisabled(false);

        if (!success) {
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      }
    };

    return (
      <div className="flex flex-col w-full justify-end p-8" style={{ height: "calc(100vh - 50px)" }}>
        
        <Conversation />

        {alert && <Alert
            text="¡Ups! Algo salió mal con el asistente. Por favor, intenta nuevamente." 
            variant="filled" 
            severity="error"
            backgroundColor="rgb(253, 235, 234)"
            color="#d32f2f"
            floating={true}
          />
        }

        {isDisabled && (
          <div className="text-start text-[#000000] text-lg animate-pulse pl-3">
            {dots}
          </div>
        )}

        <div className="mt-10">
          <TextField
            label="Escribe tu pregunta aquí..."  
            type="text" 
            value={question} 
            onChange={(e) => setQuestion(e.target.value)}
            multiline={true}
            rows={3}
            fullWidth={true}
            icon={true}
            onClick={sendQuestion}
            isDisabled={isDisabled}
          />
        </div>   

      </div>
    );
  };
  
  export default Chat;
  